import { Pitch } from "./renderer/renderer";
import { Flow as FlowRework } from "./renderer-flow/rework/renderer";

var renderer;
var flow;
var canvas;

const setupRendering = (canvasReference, viewportSize, mode) => {
  const fieldDomain = { u: 108, v: 68 };

  if (!canvas) {
    canvas = document.createElement("canvas");
  }

  canvasReference.appendChild(canvas);

  if (!renderer) {
    renderer = new Pitch(canvas, viewportSize);
    flow = new FlowRework(renderer.container, { debugFlow: mode.debug });
    renderer.fitView(0);
    renderer.container.add(flow.particlePaths);
  } else {
    renderer.viewportSize = viewportSize;
    renderer.resize();
  }

  return {
    flow,
    updateContainer: (el) => {
      el.appendChild(canvas);
    },
    setPlayers: (players) => {
      renderer.initPlayers(players);
    },
    setSize: (size) => {
      renderer.viewportSize = size;
      renderer.resize();
      renderer.fitView(0);
    },
    updateParams: (params) => {
      flow.reset(false);
      flow.updateParams(params);
      flow.updateSpheres();
      flow.makeLines();
      renderer.drawFrame();
    },
    updateFiled: (data, animate) => {
      if(data.field===undefined) return;
      flow.reset(false);
      flow.updateField(data.field);
      flow.updateWeights(data.weights);
      renderer.active = true;
      flow.updateSpheres();
      renderer.sim = flow;
      if (animate) {
        renderer.startAnimation(() => {
          //    flow.updateSpheres();
        });
      }
      renderer.drawFrame();

    },
    toggleTheme: (name) => {
      renderer.toggleTheme(name);
    },
    startAnimation: () => {},
    dispose: () => {},
    reset: () => { flow.reset(false) },
    flatView: () => {
      renderer.fitView();
    },
    angleView: () => {
      renderer.angleView();
    },
    toogleZDim: () => {
      //  renderer.toogleZDim();
    },
  };
};

export { setupRendering };
